import { FC } from 'react'
import { toAbsoluteUrl } from '../../../../../_metronic/helpers'

interface Props {
  data: {
    title: string
    value: number | string
    color: string
    icon: string
  }[]
}

export const MetricsCard: FC<Props> = ({ data }) => {
  return (
    <div className="card px-6 py-3">
      <div className='d-flex flex-wrap pt-4'>
        {data.map((metric, index) => (
          <div
            className="d-flex align-items-center mb-3 me-6"
            key={index}
            style={{ minWidth: '29.5%' }}
          >
            <div
              className="symbol symbol-40px me-5"
              style={{ backgroundColor: metric.color }}
            >
              <span className="symbol-label">
                <img
                  src={toAbsoluteUrl(metric.icon)}
                  className="h-40 align-self-center"
                  alt=""
                />
              </span>
            </div>
            <div className="d-flex flex-column">
              <span className="text-muted fs-7">{metric.title}</span>
              <span className="text-muted fw-bolder fs-1">
                {metric.value}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};